import '../neb-booking-appointment-details';
import './neb-review-login-detail';

import { LitElement, html, css } from 'lit';

import {
  CSS_SPACING,
  CSS_COLOR_HIGHLIGHT,
} from '../../../../neb-styles/neb-variables';
import '../../../../neb-lit-components/src/components/neb-loading-overlay';

export const ELEMENTS = {
  appointmentDetails: { id: 'appointment-details' },
  reviewMessage: { id: 'review-message' },
  detailPage: { id: 'detail-page' },
  serviceInfo: { id: 'service-info' },
};

export const TEXT_RESCHEDULE =
  'Please review and click "Reschedule My Appointment" to reschedule';

export const TEXT_SCHEDULE =
  'Please review and click "Book My Appointment" to schedule';

class NebReviewConfirmPage extends LitElement {
  static get properties() {
    return {
      appointment: Object,
      isReschedule: Boolean,
      layout: {
        type: String,
        reflect: true,
      },
      locations: Array,
      provider: Object,
      user: Object,
    };
  }

  static get styles() {
    return css`
      :host {
        margin: ${CSS_SPACING};
      }

      :host,
      .review-confirm-container {
        display: flex;
        flex-direction: column;
      }

      :host([layout='small']) .appointment-details {
        margin-top: ${CSS_SPACING};
      }

      .review-message {
        font-size: 16px;
        font-weight: bold;
        color: ${CSS_COLOR_HIGHLIGHT};
        margin-bottom: ${CSS_SPACING};
        padding-top: 30px;
      }
    `;
  }

  constructor() {
    super();

    this.__initState();
    this.__initHandlers();
  }

  __initState() {
    this.isReschedule = false;
    this.layout = '';
    this.locations = [];

    this.onAppointmentBooked = () => {};
  }

  __initHandlers() {
    this.__handlers = {
      appointmentBooked: () => this.onAppointmentBooked(),
    };
  }

  __getLocation() {
    const location = this.locations.find(
      l => l.id === this.appointment.locationId,
    );

    return this.locations.length > 1 ? location : null;
  }

  render() {
    return html`
      <div class="review-confirm-container">
        <span id="${ELEMENTS.reviewMessage.id}" class="review-message">
          ${this.isReschedule ? TEXT_RESCHEDULE : TEXT_SCHEDULE}
        </span>

        <div class="appointment-details">
          <neb-booking-appointment-details
            id="${ELEMENTS.appointmentDetails.id}"
            .appointment="${this.appointment}"
            .provider="${this.provider}"
            .location="${this.__getLocation()}"
          ></neb-booking-appointment-details>
        </div>

        <neb-review-login-detail
          id="${ELEMENTS.detailPage.id}"
          .user="${this.user}"
          .isReschedule="${this.isReschedule}"
          .onBook="${this.__handlers.appointmentBooked}"
        ></neb-review-login-detail>
      </div>
    `;
  }
}

customElements.define('neb-review-confirm-page', NebReviewConfirmPage);
